/**
 * LeanIQ advocate claim helper (Phase 3)
 * - Adds one Travel Pack (OTP, no selling_plan)
 * - Applies ReferralCandy THANKS- / discount code via /discount/{code}
 * - Does not touch _liq_sub_gift or _liq_referral_gift lines
 */
(function () {
  'use strict';

  var PROP_CLAIM = '_liq_advocate_claim';
  var PROP_VAL = 'travel_pack';

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function rootEl() {
    return document.querySelector('[data-liq-claim]');
  }

  function readConfig(root) {
    var cfgId = root.getAttribute('data-liq-claim-config');
    var el = cfgId ? document.getElementById(cfgId) : null;
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function setStatus(root, msg, isError) {
    var status = root.querySelector('[data-liq-claim-status]');
    if (!status) return;
    status.hidden = !msg;
    status.textContent = msg || '';
    status.classList.toggle('is-error', !!isError);
  }

  function normalizeCode(raw) {
    var code = String(raw || '').trim().toUpperCase();
    code = code.replace(/\s+/g, '');
    return code;
  }

  async function fetchCart() {
    var res = await fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('Could not read cart');
    return res.json();
  }

  function hasClaimLine(cart) {
    return (cart.items || []).some(function (item) {
      return item.properties && item.properties[PROP_CLAIM] === PROP_VAL;
    });
  }

  async function addTravelPack(variantId) {
    var res = await fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: (function () {
              var p = {};
              p[PROP_CLAIM] = PROP_VAL;
              return p;
            })()
          }
        ]
      })
    });
    var data = null;
    try {
      data = await res.json();
    } catch (e) {
      data = null;
    }
    if (!res.ok || (data && data.status && data.message)) {
      var msg = (data && (data.description || data.message)) || 'Could not add Travel Pack';
      throw new Error(msg);
    }
    return data;
  }

  function goApplyDiscount(code, redirectPath) {
    var path = redirectPath || '/cart';
    if (path.charAt(0) !== '/') path = '/' + path;
    var url = shopRoot() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
    window.location.assign(url);
  }

  async function onSubmit(e) {
    e.preventDefault();
    var root = rootEl();
    if (!root) return;

    var cfg = readConfig(root);
    var form = root.querySelector('[data-liq-claim-form]');
    var input = root.querySelector('[data-liq-claim-code]');
    var btn = root.querySelector('[data-liq-claim-submit]');
    var code = normalizeCode(input && input.value);
    var variantId = cfg.travelPackVariantId;

    if (!code) {
      setStatus(root, cfg.emptyCodeMsg || 'Enter the reward code from your email.', true);
      if (input) input.focus();
      return;
    }
    if (!variantId) {
      setStatus(root, cfg.missingVariantMsg || 'Travel Pack is not configured. Contact support.', true);
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    setStatus(root, cfg.loadingMsg || 'Adding your free Travel Pack…', false);

    try {
      var cart = await fetchCart();
      if (!hasClaimLine(cart)) {
        await addTravelPack(variantId);
      }
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { data: { source: 'leaniq-claim-reward' } }
        })
      );
      goApplyDiscount(code, cfg.redirectPath || '/cart');
    } catch (err) {
      setStatus(root, (err && err.message) || 'Something went wrong. Please try again.', true);
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  }

  function init() {
    var root = rootEl();
    if (!root) return;
    var form = root.querySelector('[data-liq-claim-form]');
    if (!form || form.getAttribute('data-liq-claim-bound') === '1') return;
    form.setAttribute('data-liq-claim-bound', '1');
    form.addEventListener('submit', onSubmit);

    var params;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (e) {
      params = null;
    }
    if (params) {
      var preset = params.get('code') || params.get('discount');
      var input = root.querySelector('[data-liq-claim-code]');
      if (preset && input && !input.value) {
        input.value = normalizeCode(preset);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
